import styled from 'styled-components';

export const ContentTable = styled.div`
  background-color: white;
  overflow: auto;
  width: 100%;
  padding: 0;

  @media (max-width: 600px) {
    white-space: nowrap;

    table {
      font-size: 0.9rem;

      th,
      td {
        padding: 8px 4px;
      }

      .MuiButton-root {
        font-size: 0.8rem;
        padding: 4px 8px;
      }

      .MuiChip-root {
        font-size: 0.75rem;
        height: 24px;
      }
    }
  }
`;

export const StyledBadge = styled.div`
  height: 20px;
  min-width: 80px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme: { colors } }) => colors.primary};
  padding: 0 8px;

  & > span {
    font-size: 0.75rem;
    font-weight: 500;
    color: white;
    line-height: 20px;
    text-align: center;
    white-space: nowrap;
  }
`;
